import { FC } from "react";

import { CMSAdvanced } from "@/components/web-experience/cms-advanced";

export const Advanced: FC = () => (
  <div className="flex-1 border-x p-8 overflow-y-scroll">
    <h3 className="text-2xl font-medium mb-4">Advanced</h3>
    <CMSAdvanced />
  </div>
);
